<template>
    <div class="lightbox-preview relative">
        <img :src="lightbox.thumbnail" :alt="lightbox.srcs[0].alt" />
        <div v-if="!lightbox.video" class="absolute bottom-3 right-3 p-2 text-neutral-500 rounded-full border border-neutral-300 bg-white z-10 opacity-90 group-hover:opacity-100 group-hover:scale-110 group-hover:text-blue-900 group-hover:border-blue-900 group-hover:p-3 group-hover:bottom-4 group-hover:right-4 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6" />
            </svg>
        </div>
        <div v-if="lightbox.video" class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 text-neutral-800 rounded-full bg-white z-10 opacity-90 group-hover:opacity-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
            </svg>
        </div>
    </div>
</template>
<script setup>
    import { inject } from 'vue';

    const lightbox = inject('lightbox');
</script>
